import { Checkbox as MUICheckbox, CheckboxProps } from '@mui/material';
import { EventType } from '@/lib/types';

export interface TrackedCheckboxProps extends Omit<
  CheckboxProps,
  'inputProps'
> {
  trackChange?: (event: any) => void;
  trackEventName?: string;
  eventType?: EventType;
  inputProps?: any;
}

export function Checkbox({
  trackChange,
  trackEventName,
  eventType = EventType.CHECKBOX_TOGGLE,
  onChange,
  inputProps,
  slotProps,
  ...props
}: TrackedCheckboxProps) {
  const handleChange: CheckboxProps['onChange'] = (event, checked) => {
    if (trackChange && trackEventName) {
      trackChange({
        name: trackEventName,
        properties: {
          eventType,
          fieldName: props.name || 'Unknown Checkbox',
          checked,
        },
      });
    }
    if (onChange) {
      onChange(event, checked);
    }
  };

  const mergedSlotProps = {
    ...(slotProps as Record<string, any> | undefined),
    ...(inputProps
      ? {
          input: {
            ...inputProps,
            ...((slotProps as Record<string, any> | undefined)?.input as
              | Record<string, any>
              | undefined),
          },
        }
      : {}),
  };

  return (
    <MUICheckbox
      {...props}
      onChange={handleChange}
      slotProps={mergedSlotProps}
    />
  );
}
